import request from '@/utils/zsm-requets'
const sms = '/zsm/api/sms/'

/**
 * 短信发送验证码
 * @param mobile 手机号
 * @param msgDict 发送类型
 */
export function sendMsgSms(mobile, msgDict) {
  return request({
    url: sms+ 'sendMsg',
    method: 'post',
    params: { mobile, msgDict }
  })
}
/**
 * 验证短信
 * @param mobile 手机号
 * @param msgDict 发送类型
 * @param code 验证码
 */
export function validMsg(params) {
  return request({
    url: sms + 'validMsg',
    method: 'post',
    params
  })
}

/**
 * 检查老师是否收短信
 * @param mobile 讲师手机号
 */
export function toggleNotify(mobile) {
  return request({
    url: sms + 'toggleNotify',
    method: 'post',
    params: { mobile }
  })
}

/**
 * 切换老师是否收短信
 * @param mobile 讲师手机号
 */
export function checkNotify(mobile) {
  return request({
    url: sms + 'checkNotify',
    method: 'post',
    params: { mobile }
  })
}

/**
 * 获取讲师购买后剩余的条数和内容
 * @param authorMobile 讲师手机号
 */
export function getAuthorSms(authorMobile) {
  return request({
    url: sms + 'getAuthorSms',
    method: 'get',
    params: { authorMobile }
  })
}

/**
 * 修改模板开启标识
 * @param openFlag 开启状态 1开启 0关闭
 * @param templateId 开启的模板id
 */
export function updateOpenFlag(params) {
  return request({
    url: sms + 'updateOpenFlag',
    method: 'get',
    params
  })
}

/*
* 讲师修改模板具体内容
*
* content:推送内容
* smsType: 1 订单提醒
* sceneType: 消息类型 ==》zsm_shop_sms_template_dict
* copyWriter:引流文案
* linkType:短信类型
* openFlag:开启状态
* qrCodeUrl:引流二维码
* userId:用户id
* */
// export function updateSmsTemplate(params) {
//   return request({
//     url: sms + 'updateSmsTemplate',
//     method: 'post',
//     params
//   })
// }
/**
 * 讲师修改模板具体内容
 * @param content 推送内容
 * @param smsType 1 订单提醒
 * @param sceneType 消息类型 ==》zsm_shop_sms_template_dict
 * @param copyWriter 引流文案
 * @param linkType  短信类型
 * @param openFlag  开启状态
 * @param qrCodeUrl  引流二维码
 * @param userId  用户id
 */
export function updateSmsTemplate(data) {
  return request({
    headers: {
      'Content-Type': 'application/json'
    },
    url: sms + 'updateSmsTemplate',
    method: 'post',
    transformRequest: [function(data) {
      data = JSON.stringify(data)
      return data
    }],
    data
  })
}


/**
 * 获取讲师短信模板列表
 * @param authorMobile 讲师手机号
 */
export function findSmsTemplate(authorMobile) {
  return request({
    url: sms + 'findSmsTemplate',
    method: 'get',
    params:{authorMobile}
  })
}

